module.exports = __webpack_public_path__ + "img/image-283.97df7490.jpg";